<!-- <p>dashboard-viewer works!</p> -->
<div class="main-dbv"
    [ngStyle]="{'grid-template-columns': '1fr '.repeat(columns), 'grid-template-rows': '1fr '.repeat(rows)}">
    <ng-container *ngIf="panels.length > 0">
        @for (panel of panels; track $index) {
            <div class="e-panel panel" [style.grid-column-start]="panel.col! + 1"
                [style.grid-row-end]="(panel.row! + 1) + panel.sizeY!" [style.grid-row-start]="panel.row! + 1"
                [style.grid-column-end]="(panel.col! + 1) + panel.sizeX!" [style.height]="getPanelHeight(panel)">
                <ng-container *ngIf="getPanelInfo(panel.id!) as info"
                    [ngTemplateOutlet]="info.isHierarchy ? hierarchyTemplates[info.templateID] : templates[info.templateID]"
                    [ngTemplateOutletContext]="getTemplateContext(info)">
                </ng-container>
            </div>
        }
    </ng-container>
</div>